import React from 'react'
import { Divider, Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import ButtonPurple from 'components/design/Form/ButtonPurple'
import classNames from 'classnames'
import style from './style.module.scss'

const ModalImportUser = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }
  const handleRecordImportUsersRequest = (requestParam = '') => {
    dispatch({
      type: 'apps/IMPORT_USERS_REQUEST_MANUAL_INTENT',
      payload: { importFrom: requestParam },
    })
  }


  const { visibleModalID } = settings
  const modalID = 'importUserRequest'
  const visible = modalID === visibleModalID

  return (
    <Modal
      className="custom__form__modal"
      title={false}
      onCancel={handleCancel}
      open={visible}
      footer={false}
      maskClosable={false}
    >
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className={classNames(style.deletedAppContainer)}>
            <div className={style.headerMain}>
              <h1>Import Users</h1>
            </div>
            <Divider
              style={{
                margin: '20px -24px',
                width: '110%',
              }}
            />

            <div className={style.bodyMain}>
              <p className={style.body}>
                Can you tell us where your user information is currently stored? Here are some
                options
              </p>
            </div>
            <Divider
              style={{
                margin: '20px -24px',
                width: '110%',
              }}
            />
            <div className={style.footerMain}>
              <ButtonPurple
                buttonText="A database"
                holderStyles={{
                  minWidth: '190px',
                  paddingBottom: '10px ',
                  margin: '0 auto',
                }}
                onClick={() => handleRecordImportUsersRequest('database')}
              />
              <ButtonPurple
                buttonText="A CSV file"
                holderStyles={{
                  minWidth: '190px',
                  paddingBottom: '10px ',
                  margin: '0 auto',
                }}
                onClick={() => handleRecordImportUsersRequest('csv-file')}
              />
              <ButtonPurple
                buttonText="Another Chat Provider"
                holderStyles={{
                  minWidth: '190px',
                  width: 'fit-content',
                }}
                onClick={() => handleRecordImportUsersRequest('another-chat-provider')}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalImportUser
